var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.smAndDown)?_c('reservation-info-mobile',{attrs:{"guest-name":_vm.guest.name,"hotel-info":_vm.hotelInfo,"reservation-info":_vm.reservationInfo,"hotel":_vm.hotel}}):_c('reservation-info-desktop',{attrs:{"guest-name":_vm.guest.name,"hotel-info":_vm.hotelInfo,"hotel":_vm.hotel,"reservation-info":_vm.reservationInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }